export default __webpack_public_path__ + "static/media/item2.32bdd4d8.jpeg";